//Articles.js

import React from 'react'
import { Text, View, StyleSheet } from 'react-native'
import styles from './Styles.js'

const Articles = () => {
  return (
    <View style={styles.column}>
      <Text style={styles.titleText}>Articles</Text>
      <Text></Text>
      <View style={styles.row}>
        <View style={styles.articlesColumnMobile}>
          <Text style={styles.titleText}>Public careers</Text>
          <Text style={styles.titleText}>High salaries and stability</Text>
          <Text style={styles.link}>Read more</Text>
          <Text> </Text>
        </View>
        <View style={styles.articlesColumnMobile}>
          <Text style={styles.titleText}>Highly successful courses at USP</Text>
          <Text style={styles.titleText}>Exact sciences, humanities, medical</Text>
          <Text style={styles.link}>Read more</Text>
          <Text> </Text>
        </View>
      </View>
      <Text> </Text>
    </View>
  )
};

export default Articles;
